// janus-engine/ability/paoe-entry-mode.ts — the persistent-AoE ENTRY frame (MV2 ASK-2; built by MV4, owner-authorized 2026-09-28).
// janus_try_persistent_aoe_entry_for_creature() re-enters janus() with use_ability_variable_1 'moving_into_p_aoe': the zone's caster, the
// entering creature the only target, the zone's connection. Every twin that branches on that sentinel reads it through here (a leaf module,
// so the roll twins can import it without a cycle through janus.ts). The PHP map: plans/janus-lane-a-ask2-paoe-entry-notes-2026-09-28.md.

export const PAOE_ENTRY = 'moving_into_p_aoe' as const;
export const PAOE_END = 'end_turn_in_p_aoe' as const;

/** True in an entry frame (janus.php's `in_array($use_ability_variable_1, ['moving_into_p_aoe', …])` for the entry sentinel). */
export function isPaoeEntry(input: { useAbilityVariable1: unknown }): boolean {
  // PHP admits both contact frames at every sentinel branch (janus, contest,
  // no-roll, upcast, targeting and preconditions). Neither pays casting costs.
  return input.useAbilityVariable1 === PAOE_ENTRY || input.useAbilityVariable1 === PAOE_END;
}
